var _defs, _g, _path, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "300 300 550 550",
    width: 40,
    height: 40,
    id: "L Alphabet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_28165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "__lottie_element_28169",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    x1: -104,
    y1: 230,
    x2: 198,
    y2: -252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "3%",
    stopColor: "rgb(0,0,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "rgb(0,62,128)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "87%",
    stopColor: "rgb(0,123,255)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_28165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1377968043088913,-0.9904597401618958,0.9904597401618958,0.1377968043088913,504.7913818359375,511.7655334472656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-28,2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,74,138)",
    fillOpacity: 1,
    d: " M0,-196 C-108.24800109863281,-196 -196,-108.24800109863281 -196,0 C-196,108.24800109863281 -108.24800109863281,196 0,196 C108.24800109863281,196 196,108.24800109863281 196,0 C196,-108.24800109863281 108.24800109863281,-196 0,-196z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#__lottie_element_28169)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 22,
    d: " M0,-196 C-108.24800109863281,-196 -196,-108.24800109863281 -196,0 C-196,108.24800109863281 -108.24800109863281,196 0,196 C108.24800109863281,196 196,108.24800109863281 196,0 C196,-108.24800109863281 108.24800109863281,-196 0,-196z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999954700469971,0,0,0.9999954700469971,497.291015625,635.3704833984375)",
    opacity: 1,
    fill: "rgb(255,191,102)",
    fontSize: 267,
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "L",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    transform: "matrix(1,0,0,1,-73.71869659423828,0)",
    opacity: 1,
    style: {
      display: "inherit"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M51.63,-189.82 C51.63,-189.82 19.95,-189.82 19.95,-189.82 C19.95,-189.82 19.95,0 19.95,0 C19.95,0 140.54,0 140.54,0 C140.54,0 140.54,-25.29 140.54,-25.29 C140.54,-25.29 51.63,-25.29 51.63,-25.29 C51.63,-25.29 51.63,-189.82 51.63,-189.82z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(2.6700000762939453,0,0,2.6700000762939453,0,0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,557,536)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(7,39,73)",
    fillOpacity: 1,
    d: "M0 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,190,102)",
    strokeOpacity: 1,
    strokeWidth: 11,
    d: "M0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03489949554204941,0.9993908405303955,-0.9993908405303955,0.03489949554204941,518.6702880859375,591.6915893554688)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(7,39,73)",
    fillOpacity: 1,
    d: "M0 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,190,102)",
    strokeOpacity: 1,
    strokeWidth: 11,
    d: "M0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.9975640773773193,0.06975647062063217,-0.06975647062063217,-0.9975640773773193,461.67498779296875,555.3287963867188)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(7,39,73)",
    fillOpacity: 1,
    d: "M0 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,190,102)",
    strokeOpacity: 1,
    strokeWidth: 11,
    d: "M0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,501,496)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(7,39,73)",
    fillOpacity: 1,
    d: "M0 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,190,102)",
    strokeOpacity: 1,
    strokeWidth: 11,
    d: "M0 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL);
export default __webpack_public_path__ + "static/media/L.b565e0dfd1821dc6618554316f317eef.svg";
export { ForwardRef as ReactComponent };